import { WSService } from "../../utils/WSService";

export const serviceSignedDocuments = new WSService("/signed-documents");
